var map = {
	"./auth/auth.module.ngfactory": [
		"./src/app/auth/auth.module.ngfactory.js",
		"auth-auth-module-ngfactory"
	],
	"./resources/resources.module.ngfactory": [
		"./src/app/resources/resources.module.ngfactory.js",
		"resources-resources-module-ngfactory"
	],
	"./strategies/strategies.module.ngfactory": [
		"./src/app/strategies/strategies.module.ngfactory.js",
		"strategies-strategies-module-ngfactory"
	],
	"./user-mgmt/user-mgmt.module.ngfactory": [
		"./src/app/user-mgmt/user-mgmt.module.ngfactory.js",
		"user-mgmt-user-mgmt-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;